var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#2E73DC",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5963 16.2967L13.8265 16.0666C13.9791 15.914 13.9791 15.6667 13.8265 15.5141L7.46281 9.15038L13.8265 2.78664C13.9791 2.63411 13.9791 2.38678 13.8265 2.2342L13.5963 2.00406C13.4438 1.85152 13.1965 1.85152 13.0439 2.00406L6.17378 8.87418C6.02124 9.02672 6.02124 9.27405 6.17378 9.42662L13.0439 16.2967C13.1965 16.4493 13.4438 16.4493 13.5963 16.2967Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.f738ec664d3bd77c64c5c6ba68002190.svg";